export function debug(message: string) {
  if ("1" !== "1") {
    return;
  }

  console.log(`%cDEBUG:%c${message}`, "color: yellow;");
}
